import { api } from "@/api"
import type { TenantAddress } from "@/composables/useTenant"
import type { ClientCurrencyCode } from "./sharedTypes/tenants"
import type { FileExportFormat } from "@/composables/options/useFileExportFormatOptions"

export type TenantCurrencyCode = "GBP" | "EUR"

export type TenantAcquirer = "barclaycard-elavon" | "evo"

export type EvoConfig = {
  gratuityIsAvailable: boolean
}

export type RetrieveSelfTenantResponse = {
  schemaName: string
  name: string
  merchantId: string
  merchantGroupName: string | null
  isDemo: boolean
  youlendOffer: number | null
  isUnlinkedRefundsEnabled: boolean
  unlinkedRefundsSingleMaximum: number
  unlinkedRefundsDailyMaximum: number
  address: TenantAddress
  defaultVatRate: number
  defaultExportFiletype: FileExportFormat

  accessControlRestrictTransactions: boolean
  accessControlRestrictReports: boolean

  isVatEnabled: boolean
  vatNumber: string

  isCashEnabled: boolean
  isTransactionReceiptsEnabled: boolean
  isReceiptQrCodeEnabled: boolean
  isGratuityEnabled: boolean
  isCardReceiptsEnabled: boolean
  isAutomaticMerchantReceiptEnabled: boolean

  isProductsEnabled: boolean
  isCashiersEnabled: boolean
  allowLoginWithoutCashier: boolean
  isServiceChargeEnabled: boolean
  defaultServiceChargePercentage: number
  defaultServiceChargeFlat: number

  isSplitPaymentsEnabled: boolean
  isOpenOrdersEnabled: boolean
  isTablesEnabled: boolean

  isAutomaticPrintingEnabled: boolean

  isHospitalityAvailable: boolean
  isHospitalityEnabled: boolean
  isCollectionEnabled: boolean

  hasDonationsModule: boolean
  hasSalesModule: boolean
  currency: ClientCurrencyCode
  acquirer: TenantAcquirer
  evoConfig: EvoConfig
}

export const retrieveSelfTenant = async () => {
  const { body } =
    await api.get<RetrieveSelfTenantResponse>(
      "/tenants/self/"
    )
  return body
}
